import { genFormData } from "@/utils/UForms";

import { TUsernameCheck } from "@/types";
import { TAuthFormValues, TRegisterFormValues } from "@/types";

import API, { publicClient, withRefreshLock } from "./api";

class AuthServiceClass {
	login(data: TAuthFormValues) {
		return publicClient
			.post(
				"auth/login",
				{
					...data,
				},
				{
					withCredentials: true,
				}
			)
			.then((res) => {
				return res.data;
			});
	}

	refreshToken() {
		// Alone across tabs: see withRefreshLock.
		return withRefreshLock(() =>
			publicClient
				.post(
					"security/refresh-token",
					{},
					{
						headers: {
							"X-Timezone":
								Intl.DateTimeFormat().resolvedOptions()
									.timeZone,
						},
						withCredentials: true,
					}
				)
				.then((res) => {
					return res.data;
				})
		);
	}

	logout() {
		return API.post("security/logout", {}, { withCredentials: true }).then(
			(res) => {
				return res.data;
			}
		);
	}

	/** Always 202, whether the address has an account or not. */
	forgotPassword(email: string): Promise<void> {
		return publicClient
			.post("auth/password/forgot", { email })
			.then(() => undefined);
	}

	/** 400 AUTH.INVALID_RESET_TOKEN on an unknown, used or expired link. */
	resetPassword(
		token: string,
		password: string,
		confirmPassword: string
	): Promise<void> {
		return publicClient
			.post("auth/password/reset", { token, password, confirmPassword })
			.then(() => undefined);
	}

	/** 400 AUTH.INVALID_EMAIL_TOKEN on an unknown, used or expired link. */
	verifyEmail(token: string): Promise<void> {
		return publicClient
			.post("auth/email/verify", { token })
			.then(() => undefined);
	}

	register(data: TRegisterFormValues) {
		const formData = genFormData<TRegisterFormValues>(data);

		return publicClient
			.post("auth/register", formData, {
				headers: {
					"Content-Type": "multipart/form-data",
				},
				withCredentials: true,
			})
			.then((res) => {
				return res.data;
			});
	}

	checkUsername(username: string): Promise<TUsernameCheck> {
		return API.get(`auth/username-check?u=${username}`).then((res) => {
			return res.data;
		});
	}
}

const AuthService = new AuthServiceClass();
export default AuthService;
